export function getNumbers(items, size) {
  if (!size) size = 10;
  const numberArray = [];
  const total = items.length;

  if (total != 0) {
    const numbers = total / size;

    for (let i = 0; i < numbers; i++) {
      numberArray.push(i + 1);
    }
  } else numberArray.push(1);

  return numberArray;
}

export function getPackageObj(packagesObj, start, end) {
  const newObj = {};
  Object.keys(packagesObj).filter((key, index) =>
    index >= start && index < end ? (newObj[key] = packagesObj[key]) : false
  );

  return newObj;
}

export function getPackageNumbers(total, size) {
  if (!size) size = 10;

  const numberArray = [];

  if (total != 0) {
    const numbers = total / size;

    for (let i = 0; i < numbers; i++) {
      numberArray.push(i + 1);
    }
  } else numberArray.push(1);

  return numberArray;
}

export function getStartIndex(page, size) {
  page = page - 1;
  const comb = page * size;
  if (!comb || comb < 0) return 0;
  else return comb;
}
